/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */


import '@polymer/neon-animation/animations/slide-from-bottom-animation.js';
import '@polymer/neon-animation/animations/slide-down-animation.js';

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';

/** 
 * `<app-dialog>` injects paper-dialog in page based on device.
 * In desktop/tablet paper-dialog will be shown in middle of page.
 * In mobile paper-dialog will be shown at bottom of page.
 * Example:
 * <app-dialog name="Name from literals"  elementid="id for paper dialog">
 *  Replace below content as per requirement. Following content is just for understanding 
 *  Content start
 * <oe-vbox class="layout center">
 * <oe-input id="profile_input_username" label="l_UserName" value="{{username}}" auto-validate error-message="Enter valid username"></oe-input>
 * <paper-button id="profile_button_update" raised class="">
 * Update
 * </paper-button>
 * </oe-vbox>
 *  Content end 
 * </app-dialog>
 * To open app-dialog, use open() function.
 * ### Styling
 * `<app-dialog>` provides the following mixins for styling:
 * Custom property | Description | Default
 * ----------------|-------------|----------
 * `--app-dialog-title' | Mixin applied to the title of the app-dialog | `{}`
 * `--app-dialog-min-height` | Minimum height of app dialog | ``
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-dialog-demo.html
 * @summary Technical component
*/
const template = html`<custom-style>
		<style include="login-styles mdl-grid-css">
			.size-position {
				position: fixed;
				bottom: 0px;
				width: 100% !important;
				min-height: var(--app-dialog-min-height, '');
				overflow: auto;
				margin: 0px;
				font-size: inherit;
				left: 0; 
			}

			.size-position[phone] {
				right: 0;
			}
			
			:dir(rtl) .size-position {
				position: fixed;
				bottom: 0px;
				width: 100% !important;
				min-height: var(--app-dialog-min-height, '');
				overflow: auto;
				margin: 0px;
				font-size: inherit;
				left: auto;
				right: 0;
			}

			.size-position[desktop],
			.size-position[tablet] {
				position: inherit;
				bottom: auto;
				min-height: var(--app-dialog-min-height, '');
				width: var(--app-dialog-width, auto) !important;
				overflow: auto;
				margin: inherit;
				font-size: inherit;
				min-width: 450px;
				left: inherit;
			}
			
			:dir(rtl) .size-position[desktop],
			.size-position[tablet] {
				position: inherit;
				bottom: auto;
				min-height: var(--app-dialog-min-height, '');
				width: var(--app-dialog-width, auto) !important;
				overflow: auto;
				margin: inherit;
				font-size: inherit;
				min-width: 450px;
				left: auto;
				right: inherit;
			}

			

		
			.paper-dialog-title {
				@apply --app-dialog-title;
			}

			.paper-dialog-wrapper {
				/*max-height: 90vh;
				overflow-y: auto;*/
				overflow-x: hidden;
			}

			.size-position[desktop] .paper-dialog-wrapper,
			.size-position[tablet] .paper-dialog-wrapper, 
			:dir(rtl) .size-position[desktop] .paper-dialog-wrapper,
			.size-position[tablet] .paper-dialog-wrapper {
				min-width: 450px;
			}

			.dialog-header-styling {
				@apply --dialog-background-color;
			}

			.dialog-text-styling {
				@apply --dialog-text-color;
			}
			.outlineOffsetClose:focus{
				outline:2px solid #FFFFFF;
			  outline-offset:1px;
				@apply --outline-offset-close;
      }

      .paper-dialog-wrapper {
				width: var(--app-dialog-paper-width, auto) !important;
        height: var(--app-dialog-paper-height, auto) !important;
      }
	    @media (max-width: 479px) {
  		.size-position {
  	        overflow: hidden !important;
  		}
      .close-label-font{
  		  color: var(--card-light-background);
  	  }
	  }
        

		</style>
		</custom-style>

		<app-media-query desktop="{{desktop}}" tablet="{{tablet}}" phone="{{phone}}"></app-media-query>

		<div></div>
		<!-- float attribute to open dialog center aligned in phone --> 
		<paper-dialog  id="{{elementid}}" class="size-position" entry-animation={{slidefrombottomanimation}} exit-animation={{slidedownanimation}}
		 on-iron-overlay-opened="patchOverlay" with-backdrop="{{backdrop}}" desktop$={{desktop}} tablet$={{tablet}} phone$={{phone}}
		 on-iron-overlay-closed="_dialogClosed" modal="{{modal}}" hidden$="{{!isPaperDialogOpened}}" opened="{{isPaperDialogOpened}}">
			<!-- this div added to give the scroll bar when the key board is open--> 
			<div class="paper-dialog-wrapper margin-zero padding-zero">
				<template is="dom-if" if="{{displayHeader}}">
					<div class="dialog-text-styling mdl-grid padding-zero dialog-header-styling">
						<div class="mdl-grid mdl-cell mdl-cell--10-col mdl-cell--3-col-phone mdl-cell--6-col-tablet mdl-cell--middle paper-dialog-title">
							<oe-i18n-msg class="text-overflow-ellipsis font-size-l" msgid="{{name}}"></oe-i18n-msg>
						</div>
						<div class="margin-b-zero mdl-cell mdl-cell--1-col-phone mdl-cell--2-col mdl-cell--2-col-tablet padding-b-zero text-align-right">
							<template is="dom-repeat" items="{{extraActionItems}}">
								<span id="app_dialog_extra_actions_{{index}}">
									<paper-icon-button  class="outlineOffsetClose" hidden$={{!item.actionIcon}} icon="{{item.actionIcon}}" on-tap="_goToAction"></paper-icon-button>
									<span class="outlineOffset text-transform-uppercase cursor-pointer" hidden$={{item.actionIcon}} on-tap="_goToAction" tabindex="0">
										{{getLabelText(item.actionText)}}
									</span>
								</span>
							</template>
							<template is="dom-if" if="{{closevisible}}">
								<paper-icon-button class="outlineOffsetClose" aria-label$="close {{getLiteral(name)}}" id="closedialog" on-keydown="backtoprevious"  on-tap="_close" icon="close" dialog-dismiss></paper-icon-button>
							</template>
							<template is="dom-if" if="{{closevisiblelabel}}">
								<div>
									<oe-i18n-msg id="closedialogLabel" class="font-size-s cursor-pointer white-color" msgid="{{closevisiblelabel}}" on-keydown="backtoprevious" on-tap="_close" dialog-dismiss>Close</oe-i18n-msg>
								</div>
							</template>
						</div>
					</div>
				</template>
				<div class="text-align-center padding-zero" wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
					<slot></slot>
				</div>
			</div>
		</paper-dialog>`;

Polymer({
	is: 'app-dialog',
	_template: template,
	properties: {
		/* id for paper-dialog */
		elementid: {
			type: String,
			notify: true
		},
		/* Name for the paper-dialog */
		name: {
			type: String,
			notify: true
		},
		/* Whether close button will be visible or not */
		closevisible: {
			type: Boolean,
			notify: true,
			value: true
		},
		closevisiblelabel: {
			type: String,
			notify: true
		},
		closeLabelVisible: {
			type: Boolean,
			notify: true,
			value: false
		},
		isPaperDialogOpened: {
			type: Boolean,			
			notify: true,			
			value: false,			
		},
		/*Dialog will not get closed when tap outside/ escape / backdrop */
		modal: {
			type: Boolean,
			notify: true,
			value: false
		},
		/* If we have to perform some action before closing dialog, put this value false and perform action and change value to true*/
		closeOnInvalid: {
			type: Boolean,
			notify: true,
			value: true
		},
		/* Boolean to display header or not */
		displayHeader: {
			type: Boolean,
			notify: true,
			value: true

		},
		/* Back drop should be present or not*/
		backdrop: {
			type: Boolean,
			notify: true,
			value: true
		},
		
		/* close callback function is the callback function called when app-dialog is closed*/
		closeCallback: {
			type: Function
		},
		/* Property for having extra actions in header*/
		extraActions: {
			type: Array,
			notify: true,
			observer: '_extraActionsChanged'
		},
		/* It is to expose label for close button for DDA */
		closeButtonLabel: {
			type: String,
			notify: true
		},
		slidefrombottomanimation:{
			type:String,
			notify:true
		},
		slidedownanimation:{
			type:String,
			notify:true
    },
    /* Flag to switch the focus to the previous element*/
    focusToggle: {
      type: Boolean,
      notify: true
    },
    /* Flag to check if Dialog is open*/
    isAppDialogOpen: {
      type: Boolean,
      notify: true
		}
	},

	/** 
	  Method to close the dialog based on closeOnInvalid flag
	**/
  _close: function (e) {
		if (this.closeOnInvalid) {
			this.$$('#' + this.elementid).close();
      if (this.isAppDialogOpen) {
        this.focusToggle = true;
        this.fire('detailsPopupTable', {
          "focusToggle": this.focusToggle
        });
        this.isAppDialogOpen = false;
		}
    }
  },
	/** 
	  Method to close the dialog from keyboard
	  @event
	**/
	backtoprevious: function (e) {
		if (e.keyCode == 40) {
			this.shadowRoot.querySelector("#confirmmsgDiv").focus();
    }
    else if (e.keyCode == 9) {
      this.focusToggle = true;
      this.fire('detailsPopupTableCloseTab', {
        "focusToggle": this.focusToggle
      });
    }
    else if (e.keyCode == 32 || e.keyCode == 13) {
      this._close(e);
      if (this.isAppDialogOpen) {
        this.focusToggle = true;
        this.fire('detailsPopupTable', {
          "focusToggle": this.focusToggle
        });
        this.isAppDialogOpen = false;
		}
    }
    //fire on-cancel-callback 
		//at present no data is sent with callback, if  required for any use case data can be added through event argument
		this.fire("cancel-callback");
	},
	ready: function(){
		if(this.phone == true){
			this.slidefrombottomanimation = 'slide-from-bottom-animation';
			this.slidedownanimation = 'slide-down-animation';
		}
	},
	/** 
	  Method to do UI changes in backdrop and model
	  @event
	**/
	patchOverlay: function (e) {
		
		// If backdrop is enabled, Removing backdropElement from its parent and attaching to parent's parent
		if (e.target.withBackdrop) {
			e.target.backdropElement.style.height = "120vh";
			e.target.parentNode.host.parentNode.insertBefore(e.target.backdropElement, e.target.parentNode.host);
		}
		if (this.closevisible) {
			setTimeout(function () {
				this.shadowRoot.querySelector("#closedialog").focus();
			}.bind(this), 500);
		}
	},
	/** 
	  Method to trigger after overlay is closed
	**/
	_dialogClosed: function () {
		var a = this.getElementsByTagName("stepup-auth")[0]
		if (a) {
			var b = a.shadowRoot.querySelector("#stepUpSubmit");
			b.disabled = true;
			b.toggleClass("text-brand-color", false);
		}
		this.fire('dialogclosed');
	},
	/** 
	  Method to trigger if more action is selected
	  @event
	**/
	_goToAction: function (e) {
		if (e.model.item.actionCallback != undefined)
			e.model.item.actionCallback();
	},
	/** 
	  Method to trigger if extra actions is modified
	  @param {array} newValue
	**/
	_extraActionsChanged: function (newValue) {
		if (typeof newValue !== 'undefined' && Array.isArray(newValue)) {
			this.set('extraActionItems', newValue);
		}
	},
	/** 
	  Method to get the label text for extraactions
	  @param {string} label
	  @return {string}
	**/
	getLabelText: function (label) {
		if (label != undefined && label !== "") {
			var displayName = getLabel(label);
			if (displayName && displayName !== "")
				return displayName;
			else
				return label;
		}
		return label;
	},
	/** 
	  Method to get the literals 
	  @param {string} literal
	  @return {string}
	**/
	getLiteral: function (literal) {
		return getLabel(literal);
	}
});
